import React, {useState} from 'react'
import {StripeProvider} from 'react-stripe-elements'
import StripeScriptLoader from 'react-stripe-script-loader'
import {CardCvcElement, CardExpiryElement, CardNumberElement, Elements} from '@stripe/react-stripe-js'
import {loadStripe} from '@stripe/stripe-js'
import BButton from 'components/Form/Fields/BButton'

const apiKey = process.env.NODE_ENV === 'production' ? 'pk_live_EaRrLqzKii5KcOTO2yN4T5HB009pT8KQ6v' : 'pk_test_TTTsDgPcJjaBcZIJ8mxnVZ0C00xYztYJVQ'
const stripePromise = loadStripe(apiKey)

const options = {
  style: {
    base: {
      iconColor: '#c4f0ff',
      // color: '#fff',
      fontWeight: 500,
      fontSize: '18px',
      fontSmoothing: 'antialiased',
      ':-webkit-autofill': {color: '#fce883'},
      '::placeholder': {color: '#e8f1f1'},
    },
    invalid: {
      iconColor: '#ffc7ee',
      color: '#ab0011',
    },
  },
}

function handleSubmit() {

}

const PaymentCard = ({}) => {
  const [data, setData] = useState({cardNumberDone: false, expDateDone: false, cvcDone: false})
  let cardNumberDone = false

  return (
    <div className='paymentCard'>
      <StripeScriptLoader
        uniqueId='myUniqueId'
        script='https://js.stripe.com/v3/'>
        <StripeProvider apiKey={apiKey}>
          <Elements stripe={stripePromise}>
            <form onSubmit={handleSubmit}>
              <label>
                Card number
                <CardNumberElement
                  className='cardInput'
                  options={options}
                  onReady={() => {
                    console.log('CardNumberElement [ready]')
                  }}
                  onChange={event => {
                    console.log('CardNumberElement [change]', event)
                    setData(d => ({...d, cardNumberDone: event.complete}))
                  }}
                  onBlur={() => {
                    console.log('CardNumberElement [blur]')
                  }}
                  onFocus={() => {
                    console.log('CardNumberElement [focus]')
                  }}
                />
              </label>
              <label>
                Expiration date
                <CardExpiryElement
                  className='cardInput'
                  options={options}
                  onReady={() => {
                    console.log('CardNumberElement [ready]')
                  }}
                  onChange={event => {
                    console.log('CardNumberElement [change]', event)
                    setData(d => ({...d, expDateDone: event.complete}))
                  }}
                  onBlur={() => {
                    console.log('CardNumberElement [blur]')
                  }}
                  onFocus={() => {
                    console.log('CardNumberElement [focus]')
                  }}
                />
              </label>
              <label>
                CVC
                <CardCvcElement
                  className='cardInput'
                  options={options}
                  onReady={() => {
                    console.log('CardNumberElement [ready]')
                  }}
                  onChange={event => {
                    console.log('CardNumberElement [change]', event)
                    setData(d => ({...d, cvcDone: event.complete}))
                  }}
                  onBlur={() => {
                    console.log('CardNumberElement [blur]')
                  }}
                  onFocus={() => {
                    console.log('CardNumberElement [focus]')
                  }}
                />
              </label>
            </form>
            {console.log(!(data.cardNumberDone && data.expDateDone && data.cvcDone))}
            <BButton disabled={!(data.cardNumberDone && data.expDateDone && data.cvcDone)} htmlType='submit'
                     key='submit' form='cardForm' vlaue='Submit'>Pay £
              4.90</BButton>
          </Elements>
        </StripeProvider>
      </StripeScriptLoader>
    </div>
  )
}

export default PaymentCard
